import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;

function baseIcon(props: P) {
  return {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    ...props,
  };
}

export function IconClock(props: P) {
  return (
    <svg {...baseIcon(props)}>
      <circle cx={12} cy={12} r={9} />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function IconBanknote(props: P) {
  return (
    <svg {...baseIcon(props)}>
      <rect x={4} y={6} width={16} height={12} rx={2} />
      <circle cx={12} cy={12} r={2} />
      <path d="M8 8h.01M16 16h.01" />
    </svg>
  );
}

export function IconCalendar(props: P) {
  return (
    <svg {...baseIcon(props)}>
      <path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
    </svg>
  );
}

export function IconUserCircle(props: P) {
  return (
    <svg {...baseIcon(props)}>
      <circle cx={12} cy={8} r={3} />
      <path d="M4 20a8 8 0 0 1 16 0" />
    </svg>
  );
}

export function IconBriefcase(props: P) {
  return (
    <svg {...baseIcon(props)}>
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <rect x={3} y={7} width={18} height={14} rx={2} />
      <path d="M3 12h18" />
    </svg>
  );
}

/** Flecha para CTAs (mini-app reservas). */
export function IconArrowRight(props: P) {
  return (
    <svg {...baseIcon({ width: 16, height: 16, ...props })}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
